const _excluded = ["theme"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useReducer, useCallback, memo } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { TRACKER_CATEGORIES } from '../constants.js';
import defaultTheme from '../defaultTheme.js';
import useRequiredCategories from '../hooks/useRequiredCategories.js';
import useSetTrackingPreference from '../hooks/useSetTrackingPreference.js';
import useTrackingPreference from '../hooks/useTrackingPreference.js';
import { useTrackingManager } from '../TrackingManagerContext.js';
import Button from './Button.js';
import CategoryLabel from './CategoryLabel.js';
import Checkbox from './CheckBox.js';
import Modal from './Modal.js';
import PrivacyLink from './PrivacyLink.js';
import Spacer from './Spacer.js';
import Text from './Text.js';
import UIProviders from './UIProviders.js';
import useMessages from './useMessages.js';
import { jsx, jsxs } from 'react/jsx-runtime';
function reducer(state, action) {
  switch (action.value) {
    case true:
      if (state.consent.includes(action.name)) return state;
      return _objectSpread(_objectSpread({}, state), {}, {
        consent: [...state.consent, action.name]
      });
    case false:
      return _objectSpread(_objectSpread({}, state), {}, {
        consent: state.consent.filter(s => s !== action.name)
      });
    default:
      return state;
  }
}
const CookieLink = str => [/*#__PURE__*/jsx(PrivacyLink, {
  color: "primary",
  children: str
}, "CookieLink")];
function CookiePreferencesModal({
  onClose,
  isOpen
}) {
  const _useTrackingManager = useTrackingManager(),
    region = _useTrackingManager.region,
    log = _useTrackingManager.log;
  useEffect(() => {
    if (isOpen) log('cookie_consent_manager_viewed');
  }, [isOpen]);
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const messages = useMessages();
  const initialTrackingPreference = useTrackingPreference();
  const initialConsent = initialTrackingPreference.consent;
  const _useReducer = useReducer(reducer, {
      consent: initialConsent,
      region
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  const requiredCategories = useRequiredCategories();
  const setTrackingPreference = useSetTrackingPreference();
  const getLogState = useCallback(state => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const logState = {};
    TRACKER_CATEGORIES.forEach(tracker => {
      logState[tracker] = state.consent.includes(tracker) ? 1 : 0;
    });
    return logState;
  }, []);
  const handleSave = useCallback(() => {
    setTrackingPreference(state);
    log('cookie_consent_manager_save_tapped', getLogState(state));
    onClose();
  }, [setTrackingPreference, onClose, state, log, getLogState]);
  const handleClose = useCallback(() => {
    // Clicking close is an affirmative action which means the user has accepted
    // the initial consent without making any changes
    setTrackingPreference(initialTrackingPreference);
    log('cookie_consent_manager_dismissed', getLogState(initialTrackingPreference));
    onClose();
  }, [setTrackingPreference, initialTrackingPreference, onClose, log, getLogState]);
  return /*#__PURE__*/jsx(Modal, {
    close: handleClose,
    isOpen: isOpen,
    title: formatMessage(messages.modalTitle),
    children: /*#__PURE__*/jsxs(Container, {
      children: [/*#__PURE__*/jsx(Text, {
        children: formatMessage(messages.modalDescription, {
          link: CookieLink
        })
      }), /*#__PURE__*/jsx(Spacer, {
        size: "md"
      }), /*#__PURE__*/jsx(Text, {
        bold: true,
        children: formatMessage(messages.manageCookies)
      }), /*#__PURE__*/jsx(Spacer, {
        size: "sm"
      }), /*#__PURE__*/jsx(CategoryContainer, {
        children: TRACKER_CATEGORIES.map(t => /*#__PURE__*/jsx(CheckBoxContainer, {
          children: /*#__PURE__*/jsx(Checkbox, {
            disabled: requiredCategories.includes(t),
            checked: state.consent.includes(t)
            // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop
            ,

            onChange: val => dispatch({
              name: t,
              value: val
            }),
            children: /*#__PURE__*/jsx(CategoryLabel, {
              name: t
            })
          })
        }, t))
      }), /*#__PURE__*/jsx(Spacer, {
        size: "lg"
      }), /*#__PURE__*/jsx(ButtonContainer, {
        children: /*#__PURE__*/jsx(Button, {
          onClick: handleSave,
          large: true,
          children: formatMessage(messages.saveCTA)
        })
      })]
    })
  });
}
function CookiePreferencesModalWithProviders(_ref) {
  let theme = _ref.theme,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(UIProviders, {
    theme: theme || defaultTheme,
    children: /*#__PURE__*/jsx(CookiePreferencesModal, _objectSpread({}, restProps))
  });
}
const CheckBoxContainer = styled.div`
  width: 50%;
  margin-bottom: ${({
  theme
}) => theme.size.md};
  @media (max-width: ${({
  theme
}) => theme.breakpoints.phone}px) {
    width: 100%;
  }
`;
const CategoryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 560px;
`;
const CookiePreferencesModal$1 = /*#__PURE__*/memo(CookiePreferencesModal);
export { CookiePreferencesModalWithProviders, CookiePreferencesModal$1 as default };
//# sourceMappingURL=CookiePreferencesModal.js.map
